export const POLICY_TYPE = {
    SERVICE_AGREEMENT: 'SERVICE_AGREEMENT',
    PRIVACY_PROTOCOL: 'PRIVACY_PROTOCOL',
    NONE: 'NONE',
};

export const RESULT_TYPE={
    SUCCESS:'SUCCESS',
    FAIL:'FAIL',
}